import { zodResolver } from '@hookform/resolvers/zod';
import { Modal, Stack } from '@mantine/core';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';

import { FileInputControl, Form, NumberInputControl } from '@/core/components';

import { Id } from '@feature/utils';

import { HIndexType } from '../model/GovEvaluationTypes';

interface GovEvaluationHIndexModalProps {
  onSubmit: (v: DataSchema) => void;
  isSubmitting: boolean;
  onClose: () => void;

  evaluationId: Id;
  hIndexType: HIndexType;
}

const schema = z.object({
  hIndex: z.number().min(0),
  file: z.instanceof(File),
  type: z.enum(['GOOGLE_SCHOLAR', 'WOS', 'SCOPUS']),
});

type DataSchema = z.infer<typeof schema>;

export function GovEvaluationHIndexModalForm(props: GovEvaluationHIndexModalProps) {
  const { onClose, isSubmitting, onSubmit, hIndexType } = props;
  const defaultValues = {
    hIndex: 0,
    type: hIndexType,
  };
  const { t } = useTranslation();
  const { control, handleSubmit } = useForm<DataSchema>({
    defaultValues,
    resolver: zodResolver(schema),
  });

  return (
    <Modal
      opened
      centered
      onClose={onClose}
      title={t(`govEvaluation.${hIndexType}`)}
    >
      <Form
        onSubmit={handleSubmit(onSubmit)}
        onCancel={onClose}
        title=""
        isSubmitting={isSubmitting}
      >
        <Stack gap="xl">
          <NumberInputControl
            label={t('govEvaluation.hIndex')}
            name="hIndex"
            control={control}
            isSubmitting={isSubmitting}
            allowDecimal={false}
            min={0}
          />
          <FileInputControl
            withAsterisk
            name="file"
            control={control}
            label={t('govEvaluation.signedPdfProof')}
            isSubmitting={isSubmitting}
            accept="application/pdf"
          />
        </Stack>
      </Form>
    </Modal>
  );
}
